import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import { styled } from "@mui/material/styles";
import EditIcon from "@mui/icons-material/Edit";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import Button from "designSystem/components/button/Button";
import { grey } from "designSystem/styles/color";
import GridItemGrow from "designSystem/components/grid/GridItemGrow";
import { Grid } from "designSystem/index";
import ColorSelect from "designSystem/components/select/ColorSelect";
import { PinColor } from "csi/model/comment";
import { useStore } from "csi/state/hooks";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";

const PREFIX = "ThreeDPinComponents";

const classes = {
	editIconColor: `${PREFIX}editIconColor`,
};

const StyledGrid = styled(Grid)((
	{
		theme,
	},
) => ({
	//this is to fix a primary button class overriding edit button icon class while switching to edit mode
	[`& .${classes.editIconColor}`]: {
		color: grey["A100"] + " !important",
	},
}));

export const ThreeDPinComponents: FunctionComponent = observer(() => {
	const { commentsStore } = useStore();

	const {
		addPin,
		cancelUpdatePin,
		removePin,
		movePin,
		newPin,
		onChangePinColor,
		pinColor,
		pinColorCategoryItems,
		pinIsMoving,
		pinEditMode,
		saveUpdatePin,
	} = commentsStore;

	const defaultPinColor = newPin?.color || pinColor;
	const addPinHandler = () => addPin();
	const removePinHandler = () => removePin(true);

	return (
		<StyledGrid
			container
			direction="row"
			fullHeight
			spacing={1}
		>
			<Grid item>
				<ColorSelect
					disabled={pinEditMode}
					fullWidth
					items={pinColorCategoryItems}
					onChange={(event) => {
						onChangePinColor(event.target.value as PinColor);
					}}
					value={defaultPinColor}
				/>
			</Grid>
			{!newPin ? (
				<GridItemGrow p={1}>
					<Button
						design="secondary"
						fullWidth
						onClick={addPinHandler}
						res="ConversationAddPin"
						startIcon={<AddCircleRoundedIcon color="primary" />}
					/>
				</GridItemGrow>
			)
				: (
					<>
						<GridItemGrow p={1}>
							{!pinIsMoving ? (
								<Button
									design="secondary"
									disabled={pinIsMoving}
									fullWidth
									onClick={movePin}
									res="ConversationMovePin"
									startIcon={(
										<EditIcon
											className={classes.editIconColor}
										/>
									)}
								/>
							)
								: (
									<Button
										design="primary"
										fullWidth
										onClick={saveUpdatePin}
										res="ConversationSavepin"
									/>
								)}
						</GridItemGrow>
						<GridItemGrow p={1}>
							{!pinIsMoving ? (
								<Button
									design="secondary"
									disabled={pinIsMoving}
									fullWidth
									onClick={removePinHandler}
									res="ConversationRemovePin"
									startIcon={<RemoveCircleIcon color="primary" />}
								/>
							)
								: (
									<Button
										design="secondary"
										fullWidth
										onClick={cancelUpdatePin}
										res="Cancel"
									/>
								)}
						</GridItemGrow>
					</>
				)}
		</StyledGrid>
	);
});

export default ThreeDPinComponents;